const BUILD_CACHE_TAG_PREFIX = "repackify-build:";

export function buildCacheTag(versionId: string): string {
  return `${BUILD_CACHE_TAG_PREFIX}${versionId}`;
}

export const FRESH_BUILD_PARAM = "__repackify_fresh";

// WHY: the Worker sets this from FRESH_BUILD_PARAM and never passes a client's copy.
export const REFRESH_STALE_BUILD_HEADER = "x-repackify-refresh-stale-build";

export type FreshBuildReason = "release" | "stale-action";

const FRESH_BUILD_VALUES: Record<FreshBuildReason, string> = { release: "1", "stale-action": "action" };

export function freshBuildUrl(href: string, reason: FreshBuildReason = "release"): string {
  const url = new URL(href);
  url.searchParams.set(FRESH_BUILD_PARAM, FRESH_BUILD_VALUES[reason]);
  return url.toString();
}

export function freshBuildReason(value: string | null): FreshBuildReason | null {
  if (value === null) return null;
  return value === FRESH_BUILD_VALUES["stale-action"] ? "stale-action" : "release";
}

export const ASSET_ARCHIVE_PREFIX = "asset-archive/";
export const ARCHIVED_ASSET_PATH_PREFIX = "/_next/static/";
export const ASSET_ARCHIVE_PATH = "/__repackify/asset-archive";
export const ASSET_ARCHIVE_BATCH_LIMIT = 100;

export function isArchivedAssetPath(pathname: string): boolean {
  return pathname.startsWith(ARCHIVED_ASSET_PATH_PREFIX) && !pathname.split("/").some((segment) => segment === ".." || segment === ".");
}

export function assetArchiveKey(pathname: string): string {
  return `${ASSET_ARCHIVE_PREFIX}${pathname.slice(1)}`;
}
